export const createLabDiagnosticsFields = [
    {
        name: "lab_name",
        label: "Lab Name",
        type: "text",
            placeholder: "Eg. Fusion Labs",

        required: true,
        colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg: 1
        },
    },
    {
        name: "mobile",
        label: "Mobile Number",
            placeholder: "Eg. 8569841259",

        type: "mobile",
        required: true,
        colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg: 1
        },
    },
    {
        name: "email",
        label: "Email",
        type: "email",
            placeholder: "Eg. fusion@gmail.com",

        colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg: 1
        },
    },
    {
        name: "address",
        label: "Address",
        type: "textarea",
        colSpan: 6,
    },
    {
        name: "status",
        label: "Status",
        type: "select",
        colSpan: {
            base: 6,
            sm: 4,
            md: 2,
            lg:1
        },
        options: [
            { value: "active", label: "Active" },
            { value: "inActive", label: "InActive" },
        ],
    },

];


